<template>
<div :class="isMobileDevice()?'phone':'pc'">
  <router-view class="app" />
</div>
</template>

<script>
export default {
  name: 'App',
  methods: {
    isMobileDevice() {
      return /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    },
  }

}
</script>

<style lang="scss">
html,
body {

  /* 隐藏垂直滚动条 */
  .parent::-webkit-scrollbar {
    width: 0;
  }
}
</style>
